import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import fallbackTranslations from "./locales/pt.json";
import AxiosInstance from "./api/AxiosInstance.js";

// Initialize i18next
// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/api/cross-region/configs/language/{{lng}}/translations",
      allowMultiLoading: false,
      request: (opts, url, payload, callback) => {
        AxiosInstance
          .get(url)
          .then(res => callback(null, { status: res.status, data: JSON.stringify(res.data) }))
          .catch(err => {
            const status = err?.response?.status ?? 500;
            const data = err?.response?.data ? JSON.stringify(err.response.data) : null;
            callback(err, { status, data });
          });
      },
    },
    fallbackLng: false,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  })

i18n.on("failedLoading", (lng, ns, msg) => {
  console.warn(`Failed to load ${ns} for ${lng}: ${msg}`);
  i18n.addResourceBundle("pt", "translation", fallbackTranslations, true, true);
});

export default i18n;
